export default __webpack_public_path__ + "static/media/file.8fa3f210.svg";